/* eslint-disable tailwindcss/no-custom-classname */
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SelectVariant from '../../../atoms/select/SelectVariant';

const ColorSelector = ({
  variants: colorProducts,
  setIsChooseSize,
  setIsClicked,
  onChangeColorProducts,
  onUpdateSkuToUrl,
  onChangeSizeVariant,
  refererStore,
  context,
}) => {
  const updateUrlAfterSelectedColor = (colorVariant) => {
    if (_.isEmpty(colorVariant)) {
      return;
    }

    onUpdateSkuToUrl?.(null);
  };

  const updateSizeColor = async (colorVariant) => {
    // updateUrlAfterSelectedColor(colorVariant);

    const newProductColors = [...colorProducts].map((item) => {
      item.isActive = false;

      if (item.product.productId === colorVariant.product.productId) {
        item.isActive = true;
        // sizeOfColor = item.product.variants;
      }
      return item;
    });

    await onChangeColorProducts(newProductColors);
  };

  const countTotal = () => colorProducts.length;

  return (
    <div className={'select-variants-component'}>
      <div className={'select-attribute label-name color-label leading-4 underline'}>
        <FormattedMessage id={'product.color'} />:
      </div>

      <div className={'select-variant-wrapper'}>
        <div className={'select-variant-total font-bold'}>
          {countTotal()} <FormattedMessage id={'product.colorTotal'} />
        </div>

        <SelectVariant
          variants={colorProducts}
          formatLabel={(option) => option.variants[0].attributes.att_prod_color_name_mf}
          isVariantColor
          refererStore={refererStore}
          context={context}
          onSelectColor={(color) => {
            setIsChooseSize(false);
            setIsClicked(false);
            updateSizeColor(color);
          }}
        />
      </div>
    </div>
  );
};

ColorSelector.propTypes = {
  variants: PropTypes.array.isRequired,
  onChangeSizeVariant: PropTypes.func.isRequired,
  setIsChooseSize: PropTypes.func.isRequired,
  setIsClicked: PropTypes.func.isRequired,
  onChangeColorProducts: PropTypes.func.isRequired,
  onUpdateSkuToUrl: PropTypes.any,
  refererStore: PropTypes.any,
  context: PropTypes.any,
};

export default ColorSelector;
